// third-party
import { FormattedMessage } from 'react-intl';

// project import
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - COMPONENTS ||============================== //

const menuItems: NavItemType[] = [
];

export default menuItems;
